export const GET_USER_LIST = "GET_USER_LIST";
export const USER_LIST = "USER_LIST";

export const SEARCH_USER_BY_ID = "SEARCH_USER_BY_ID";
export const USER_BY_ID = "USER_BY_ID";

export const SEARCH_USER_BY_FIELD = "SEARCH_USER_BY_FIELD";
export const USER_BY_FIELD_LIST = "USER_BY_FIELD_LIST";

export const ADD_USER = "ADD_USER";
export const ADD_USER_RESPONSE = "ADD_USER_RESPONSE";

export const UPDATE_USER = "UPDATE_USER";
export const UPDATE_USER_RESPONSE = "UPDATE_USER_RESPONSE";

export const DELETE_USER = "DELETE_USER";
export const DELETE_USER_RESPONSE = "DELETE_USER_RESPONSE";

export const GET_USER_LIST_BY_PARTNER_ID = "GET_USER_LIST_BY_PARTNER_ID";
export const USER_LIST_BY_PARTNER_ID = "USER_LIST_BY_PARTNER_ID";

export const GET_PARTNERS_LIST = "GET_PARTNERS_LIST";
export const PARTNERS_LIST = "PARTNERS_LIST";

export const GET_ADMIN_LIST = "GET_ADMIN_LIST";
export const ADMIN_LIST = "ADMIN_LIST";
